module.exports = __webpack_public_path__ + "img/yw_2.d4b18473.png";